<!-- 标题配置 -->
<template>
    <div class="config-box">
        <el-form-item label="轴标题" label-width="80">
            <FontSet renderType="color, size" v-model=axisTitleSet></FontSet>
        </el-form-item>
        <el-form-item label="轴标签" label-width="80">
            <FontSet renderType="color, size" v-model="axisLabelSet"></FontSet>
        </el-form-item>
        <el-form-item label="数据标签" label-width="80">
            <FontSet renderType="color, size" v-model="seriesLabelSet"></FontSet>
        </el-form-item>
        <el-form-item label="工具提示" label-width="80">
            <FontSet renderType="color, size" v-model="toolTipSet"></FontSet>
        </el-form-item>
        <el-form-item label="图例" label-width="80">
            <FontSet renderType="color, size" v-model="legendSet"></FontSet>
        </el-form-item>
        <el-form-item label="x轴" label-width="80">
            <FontSet renderType="color, size" v-model="xAxisSet"></FontSet>
        </el-form-item>
        <el-form-item label="y轴" label-width="80">
            <FontSet renderType="color, size" v-model="yAxisSet"></FontSet>
        </el-form-item>
        <el-form-item label="网格线" label-width="80">
            <div class="flex">
                <el-select v-model="splitLineBorderType" size="small" class="mr-8">
                    <el-option
                        label="实线"
                        value="solid"
                        ></el-option>
                    <el-option
                        label="虚线"
                        value="dashed"
                        ></el-option>
                    <el-option
                        label="点线"
                        value="dotted"
                        ></el-option>
                </el-select>
                <FontSet renderType="color, size" v-model="splitLineSet"></FontSet>
            </div>
        </el-form-item>
    </div>
</template>
  
<script>
import FontSet from './fontSet.vue'

export default {
    name: "chartConfig",
    data() {
        return {
            axisTitleSet: this.modelValue?.axisTitleSet,
            axisLabelSet: this.modelValue?.axisLabelSet,
            seriesLabelSet: this.modelValue?.seriesLabelSet,
            toolTipSet: this.modelValue?.seriesLabelSet,
            legendSet: this.modelValue?.legendSet,
            xAxisSet: this.modelValue?.xAxisSet,
            yAxisSet: this.modelValue?.yAxisSet,
            splitLineSet: this.modelValue?.splitLineSet,
            splitLineBorderType: this.modelValue?.splitLineBorderType,
        }
    },
    props: {
        modelValue: {
            type: Object,
            default: () => {
                return {
                    axisTitleSet: {},
                    axisLabelSet: {},
                    seriesLabelSet: {},
                    toolTipSet: {},
                    legendSet: {},
                    xAxisSet: {},
                    yAxisSet: {},
                    splitLineSet: {},
                    splitLineBorderType: ''
                }
            }
        },
    },
    watch: {
        axisTitleSet: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    axisTitleSet: val,
                })
            },
        },
        axisLabelSet: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    axisLabelSet: val,
                })
            },
        },
        seriesLabelSet: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    seriesLabelSet: val,
                })
            },
        },
        toolTipSet: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    toolTipSet: val,
                })
            },
        },
        legendSet: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    legendSet: val,
                })
            },
        },
        xAxisSet: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    xAxisSet: val,
                })
            },
        },
        yAxisSet: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    yAxisSet: val,
                })
            },
        },
        splitLineSet: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    splitLineSet: val,
                })
            },
        },
        splitLineBorderType(val) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                splitLineBorderType: val,
            })
        },
    },
    components: {
        FontSet,
    },
    mounted() {
    },
    methods: {
    }
};
</script>
  
<style lang="scss" scoped>
.config-box {
    padding: 5px 0;
}
</style>